import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["name", "options", "option", "unit"];

  refresh() {
    this.nameTarget.textContent = this.element
      .querySelector("textarea")
      .value.trim();

    this.optionsTarget.replaceChildren(
      ...this.#options.map((option) => this.#chip(option)),
    );

    this.unitTargets.forEach((unit) => (unit.textContent = this.#unit));
  }

  get #unit() {
    return (
      this.element.querySelector("[name$='[settings][unit]']")?.value.trim() ??
      ""
    );
  }

  get #options() {
    return [...this.element.querySelectorAll("[name$='[options][]']:enabled")]
      .map((input) => input.value.trim())
      .filter(Boolean);
  }

  #chip(option) {
    const chip = this.optionTarget.content.firstElementChild.cloneNode(true);
    chip.textContent = option;
    return chip;
  }
}
